import { useState } from "react";
import { useDispatch } from "react-redux";
import { getGifs } from "../../redux/gifs_actions";
import styles from "./Searchbar.module.css";
import { useNavigate, useLocation } from "react-router-dom";

function Searchbar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [name, setName] = useState("");

  const handleChange = (e: any) => {
    setName(e.target.value);
  };

  const handleSubmit = (e: any) => {
    if (
      pathname.includes("/gif") ||
      pathname.includes("/profile") ||
      pathname.includes("/random")
    ) {
      navigate(`/gifs/${name}`);
    }
    e.preventDefault();
    dispatch(getGifs(name));
  };

  return (
    <form onSubmit={handleSubmit} className={styles.form}>
      <span id={styles.search}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
        </svg>
      </span>
      <input
        type="text"
        autoComplete="off"
        className={styles.input}
        placeholder="Search"
        onChange={handleChange}
      />
    </form>
  );
}

export default Searchbar;
